import { useState } from 'react';
import { SkillCard } from './SkillCard';
import { Label } from 'src/components/Label';
import { Input } from 'src/components/Input';
import { Button } from 'src/components/Button';

type CollectionDatum = {
  name: string;
  description: string;
};

export const InformationCollectionSkill = ({
  config,
  onConfigChange,
}: {
  config: object;
  onConfigChange?: (config: object) => void;
}) => {
  const [entries, setEntries] = useState<CollectionDatum[]>([]);

  return (
    <SkillCard title="INFORMATION COLLECTION">
      {entries.map((entry) => (
        <div className="flex mt-2 gap-4">
          <div>
            <Label>Name</Label>
            <Input />
          </div>
          <div className="w-full">
            <Label>Description</Label>
            <Input />
          </div>
        </div>
      ))}
      <Button
        className="mt-2"
        onClick={() => setEntries([...entries, { name: '', description: '' }])}
      >
        Add Info to Collect
      </Button>
    </SkillCard>
  );
};
